export const Communication_Portal = "P";
export const Communication_PortalAndEmail = "C";
export const Communication_SMS = "T";
export const Communication_Both = "2";